import React from "react";
import "../../App.scss";
import { CMdSPortals , SELECT_ORG} from "../../SharedModules/AppConstants";
import { PROVIDER_PORTAL_LP } from "../../SharedModules/Navigation/RouteConstants";

function ProfileCard(props) {
  const { userData, fromPortal, portalLogOut, url } = props;
  const [organizationList, setOrganizationList] = React.useState([]);

  React.useEffect(() => {
  const interval = setInterval(() => {
    const orgList = localStorage.getItem("orgList");
    const orgListDetails = orgList && orgList !== 'undefined' ? JSON.parse(orgList) : [];
    if (orgListDetails.length > 0) {
      setOrganizationList(orgListDetails);
      clearInterval(interval); // stop polling once loaded
    }
  }, 500); // poll every 500ms
 
  return () => clearInterval(interval);
}, []);

  const makeTabActive = () => {
    if (stateImpInd === 'Y' && url) {
      const tabToActivate = window.open('', SELECT_ORG);
      // env file product dev
      if (tabToActivate && !tabToActivate.closed) {
        tabToActivate.focus();
      }else {
        tabToActivate = window.open(process.env.REACT_APP_PRODUCT_URL + PROVIDER_PORTAL_LP, SELECT_ORG);
      }
      } else {
        const tabToActivate = window.open(
          process.env.REACT_APP_PRODUCT_URL,
          CMdSPortals
        ); // env file product dev
        if (!tabToActivate.closed) {
          tabToActivate.focus();
        }
      }
  };

  const getUrl = (h, orgId, name) => {
    return `${h}?user=${userData.loginUserId}&accessToken=${localStorage.getItem("accessToken")}&refreshToken=${localStorage.getItem("refreshToken")}&orgID=${orgId}&orgName=${name}&impStateLoginInd=Y`;
  };

  const logo = userData?.lastName?.charAt(0) + userData?.firstName?.charAt(0);
  const userName =
    userData?.firstName && userData?.lastName
      ? userData?.lastName + " " + userData?.firstName
      : "";
  const email = userData?.email;
  const stateImpInd = localStorage.getItem("impStateLoginInd");

  const totalOrgList = organizationList?.filter(item => item.orgId != userData?.orgID);

  const handleOrgList = (orgId, name) => {
    window.open(getUrl(url, orgId, name), '_self');
  };

  return (
    userName && (
      <div class="profile_card">
        <div class="card-body">
          <div className={stateImpInd == "N" ? "row" : "row mb-30"}>
            <div className="col">
              {stateImpInd == "Y" ? (
                <span className={"card-logo-border cardLogoNM"}>
                  {logo ? logo : ""}
                </span>
              ) : (
                <span className={"card-logo-border cardLogo"}>
                  {logo ? logo : ""}
                </span>
              )}
            </div>
            <div className="card_detail">
              <h6
                title={userName ? userName : ""}
                class="card-subtitle mb-2 card_wordWrapper"
              >
                {userName ? userName : ""}
              </h6>
              {stateImpInd == "Y" ? (
                <p className="card-subtitle mb-2 card_wordWrapper font9">
                  {email}
                </p>
              ) : (
                <p title={email} className="card-text card_wordWrapper font12">
                  {email}
                </p>
              )}

              <div>
                <a
                  class="card-link"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    makeTabActive(CMdSPortals, "");
                  }}
                >
                  Home
                </a>
              </div>
              {stateImpInd != "Y" && (
                  <div>
                    <a
                      class="card-link"
                      style={{ cursor: "pointer" }}
                      onClick={
                        fromPortal
                          ? props.handleMyaccount
                          : props.navigateToMyAccount
                      }
                    >
                      My Account
                    </a>
                  </div>
                )}
            </div>
          </div>
        </div>
        {stateImpInd == "Y"  && url ? (
          <>
            <div className="profile-container">
              <div className="active-signedin">You're signed in with</div>
              <div class="active-org">
                <div class="org-title">
                  {userData?.orgID} - {userData?.orgName}
                  <i class="fa fa-check checkmark"></i>
                </div>
                <div class="active-label">Currently Active</div>
              </div>
              {organizationList.length > 1 ? 
              <>
                <div className="section-title">
                    Other organizations you belong to
                </div>
                <div className="org-list">
                  {totalOrgList.map((org) => (
                    <div className="org-card" key={org.orgId}
                      onClick={() => {
                        handleOrgList(org.orgId, org.name);
                      } }>
                      <div>
                        {org.orgId} - {org.name}
                      </div>
                      <a href={`${url}?user=${userData.loginUserId}&accessToken=${localStorage.getItem("accessToken")}&refreshToken=${localStorage.getItem("refreshToken")}&orgID=${org.orgId}&orgName=${org.name}&impStateLoginInd=Y`}><u>Switch to this Organization</u></a>
                    </div>
                  ))}
                </div>
              </>
              : '' }
            </div>
          </>
        ) : (
          <div className={`card-footer logOut text-right bg-white`}>
            <a
              class="card-link text-dark text-decoration-none"
              style={{ cursor: "pointer" }}
              onClick={portalLogOut ? props.logOutFromPortal : props.logOut}
            >
              {process.env.REACT_APP_LOGOUT || "Logout"}
            </a>
          </div>
        )}
      </div>
    )
  );
}
export default ProfileCard;
